var BASWebServices;
(function (BASWebServices) {
    var ToolTipController = (function () {
        function ToolTipController($scope, $rootScope, toolTipService) {
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.toolTipService = toolTipService;
            $scope.ttc = this;
            this.$scope.SHOW_TOOLTIP = false;
        }
        ToolTipController.prototype.toogleToolTip = function () {
            this.toolTipService.closeOldAndregisterNewInstance(this);
            this.$scope.SHOW_TOOLTIP = !this.$scope.SHOW_TOOLTIP;
        };
        ToolTipController.prototype.closeToolTip = function () {
            this.$scope.SHOW_TOOLTIP = false;
        };
        ToolTipController.prototype.doNothing = function ($event) {
            $event.stopPropagation();
        };
        return ToolTipController;
    }());
    BASWebServices.ToolTipController = ToolTipController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=ToolTipController.js.map